export default __webpack_public_path__ + "static/media/critical.8637950d.png";